import { render, staticRenderFns } from "./CalculationBox.vue?vue&type=template&id=752580c2&"
import script from "./CalculationBox.vue?vue&type=script&lang=js&"
export * from "./CalculationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports